import { FilterParams } from '../../../typings/marketers';

export const UPDATE_INTERNAL_MARKETERS_FILTER_PARAMS = 'UPDATE_INTERNAL_MARKETERS_FILTER_PARAMS';
export type UPDATE_INTERNAL_MARKETERS_FILTER_PARAMS = typeof UPDATE_INTERNAL_MARKETERS_FILTER_PARAMS;

export interface UpdateInternalMarketersFilterParams {
    type: UPDATE_INTERNAL_MARKETERS_FILTER_PARAMS;
    params: FilterParams;
}
export function updateInternalMarketersFilterParamsAction(params: FilterParams): UpdateInternalMarketersFilterParams {
    return {
        type: UPDATE_INTERNAL_MARKETERS_FILTER_PARAMS,
        params
    };
}
